const IS_DISABLED = 'is--disabled';

function getGroupTotal($group) {
    let total = 0;
    $group.find('.stepgroup-qty').each(function(index, item) {
        total += parseInt($(item).val());
    });
    return total;
}

function updateRemainingItemsText(groupMax, total, $group) {
    let remaining = groupMax - total;

    if(remaining === 0) {
        $('.step-group-max').text(function() {
            return `${total} Items Added`;
        });

        $group.addClass('complete');
    } else {
        $('.step-group-max').text(function() {
            return `Add ${remaining} Items`;
        });
        $group.removeClass('complete');
    }
}

function performIncrementOrDecrementLogic($clickedBtn) {
    let $input = $(`input[name="${$clickedBtn.data('field')}"]`);
    let value = parseInt($input.val());
    let $optionCard = $clickedBtn.closest('.option-card');
    let groupMax = 2;
    let $group = $clickedBtn.closest('.pack-builder__step');
    let total = getGroupTotal($group);
    let cardSelected = 'card-selected';
    let valueMin = 0;

    // Check if a number is in the field first
    if(isNaN(value) || value < valueMin) {
        // If field value is NOT a number, or
        // if field value is less than minimum,
        // ...set value to 0 and exit function
        $input.val(valueMin);
        return false;
    } else if(value > groupMax) {
        // If field value exceeds maximum,
        // ...set value to max
        $input.val(groupMax);
        return false;
    }

    // Perform increment or decrement logic
    if($clickedBtn.data('func') === 'plus') {
        if(total < groupMax) {
            $input.val(value + 1);
            total++;
        }
        if(value >= 0) {
            $optionCard.addClass(cardSelected);
        }

        $optionCard.find('.qty-addsub-minus').removeClass(IS_DISABLED);
        if(value === groupMax) {
            $optionCard.find('.qty-addsub-plus').addClass(IS_DISABLED);
        }
    } else {
        if(value > valueMin) {
            $input.val(value - 1);
            total--;
        }

        if(value <= 1) {
            value = 1;
            $optionCard.find('.qty-addsub-minus').addClass(IS_DISABLED);
        } else {
            $optionCard.find('.qty-addsub-plus').removeClass(IS_DISABLED);
        }
    }

    if($clickedBtn.data('func') === 'minus') {
        if(value === 1) {
            $optionCard.removeClass(cardSelected);
        }
    }

    updateRemainingItemsText(groupMax, total, $group);
}

function handleQuantityClicking(e) {
    let $this = $(this);
    let $clickedBtn = '';

    if(e.length) {
        $clickedBtn = $(e);
    } else {
        $clickedBtn = $this;
    }

    performIncrementOrDecrementLogic($clickedBtn);
}
function initEventHandlers() {
    $('.free-product').on('click', '.qty-addsub', handleQuantityClicking);
}
$(function () {
    initEventHandlers();
});
